/**
 * ENFAMI Premium — interactions page produit
 */
(function () {
  'use strict';

  const main = document.querySelector('#MainContent');
  if (main?.dataset.template !== 'product') return;

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MOBILE = window.matchMedia('(max-width: 989px)').matches;

  /* ── Galerie morph au changement de variante ── */
  function initGalleryMorph() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || REDUCED) return;

    document.addEventListener('variant:update', () => {
      const active = gallery.querySelector(
        '.product-media-container.is-active, slideshow-slide[aria-hidden="false"], [data-media-id].is-active'
      );
      if (!active) return;
      active.animate(
        [{ opacity: 0.35, transform: 'scale(0.96) rotate(0.5deg)' }, { opacity: 1, transform: 'scale(1) rotate(0deg)' }],
        { duration: 580, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
    });

    gallery.querySelectorAll('slideshow-slide, .product-media-container').forEach((slide) => {
      slide.addEventListener('click', () => {
        if (REDUCED) return;
        slide.animate(
          [{ filter: 'brightness(1.1)' }, { filter: 'brightness(1)' }],
          { duration: 400, easing: 'ease-out' }
        );
      });
    });
  }

  /* ── Transition morph entre slides galerie ── */
  function initSlideshowMorph() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || REDUCED) return;

    gallery.addEventListener('slideshow:select', (e) => {
      const slides = gallery.querySelectorAll('slideshow-slide, .product-media-container');
      slides.forEach((s) => {
        s.style.transition = 'opacity 0.45s cubic-bezier(0.22,1,0.36,1), transform 0.45s cubic-bezier(0.22,1,0.36,1)';
      });
    });
  }

  /* ── Zoom HD desktop (loupe) ── */
  function initDesktopZoom() {
    if (MOBILE || REDUCED) return;

    const gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.dataset.zoomInit === 'true') return;
    gallery.dataset.zoomInit = 'true';

    gallery.addEventListener('mouseover', (e) => {
      const mediaWrap = e.target.closest('.product-media-container, slideshow-slide');
      if (!mediaWrap) return;
      const img = mediaWrap.querySelector('img');
      if (!img) return;

      let lens = mediaWrap.querySelector('.enfami-zoom-lens');
      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'enfami-zoom-lens';
        lens.setAttribute('aria-hidden', 'true');
        mediaWrap.style.position = 'relative';
        mediaWrap.appendChild(lens);
      }

      const zoomLevel = 2.2;
      const onMove = (ev) => {
        const rect = mediaWrap.getBoundingClientRect();
        const x = ((ev.clientX - rect.left) / rect.width) * 100;
        const y = ((ev.clientY - rect.top) / rect.height) * 100;
        lens.style.backgroundImage = `url('${img.currentSrc || img.src}')`;
        lens.style.backgroundSize = `${rect.width * zoomLevel}px ${rect.height * zoomLevel}px`;
        lens.style.backgroundPosition = `${x}% ${y}%`;
        lens.style.left = ev.clientX - rect.left - lens.offsetWidth / 2 + 'px';
        lens.style.top = ev.clientY - rect.top - lens.offsetHeight / 2 + 'px';
        lens.classList.add('is-active');
      };
      const onLeave = () => lens.classList.remove('is-active');

      mediaWrap.addEventListener('mousemove', onMove);
      mediaWrap.addEventListener('mouseleave', onLeave, { once: true });
    });
  }

  /* ── Micro-interactions sélecteur variante ── */
  function initVariantSwap() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;

    picker.addEventListener('change', (e) => {
      if (REDUCED) return;
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) return;
      const label = target.closest('label') || target.parentElement;
      label?.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.14)' }, { transform: 'scale(1.04)' }],
        { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    });

    document.querySelectorAll('.variant-picker__option-value, variant-picker label').forEach((el) => {
      el.addEventListener('click', () => {
        if (REDUCED) return;
        el.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.1)' }, { transform: 'scale(1.03)' }],
          { duration: 280, easing: 'ease-out' }
        );
      });
    });
  }

  /* ── Configurateur flocage — panel animé ── */
  function initConfiguratorPremium() {
    const root = document.querySelector('[data-enfami-configurator]');
    if (!root) return;

    const panel = root.querySelector('[data-efc-flocage-panel]');
    if (!panel) return;

    const observer = new MutationObserver(() => {
      if (panel.hidden) return;
      if (REDUCED) return;
      panel.animate(
        [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' }
      );
    });
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });

    root.querySelectorAll('.efc__input, .efc__select').forEach((input) => {
      input.addEventListener('focus', () => input.classList.add('is-focused'));
      input.addEventListener('blur', () => input.classList.remove('is-focused'));
    });

    const uploadZone = root.querySelector('[data-efc-upload-zone]');
    if (uploadZone) {
      ['dragenter', 'dragover'].forEach((ev) => {
        uploadZone.addEventListener(ev, (e) => {
          e.preventDefault();
          uploadZone.classList.add('is-dragover');
        });
      });
      uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('is-dragover'));
      uploadZone.addEventListener('drop', () => uploadZone.classList.remove('is-dragover'));
    }
  }

  /* ── Bouton ATC animé ── */
  function initAddToCartAnimation() {
    const forms = document.querySelectorAll('product-form-component form, form[action*="/cart/add"]');

    forms.forEach((form) => {
      form.addEventListener('submit', () => {
        const btn =
          form.querySelector('[type="submit"]') ||
          form.querySelector('.product-form__submit') ||
          form.querySelector('button[name="add"]');
        if (!btn || btn.classList.contains('is-success')) return;

        btn.classList.add('is-loading', 'enfami-btn-premium');
        const original = btn.innerHTML;

        const onAdded = () => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');

          if (!btn.querySelector('.enfami-btn-premium__check')) {
            btn.innerHTML =
              '<span class="enfami-btn-premium__label">' +
              original +
              '</span><span class="enfami-btn-premium__check" aria-hidden="true">✓</span>';
          }

          if (!REDUCED) {
            var runConfetti = function () {
              if (!window.confetti) return;
              window.confetti({
                particleCount: 56,
                spread: 70,
                origin: { y: 0.7 },
                colors: ['#ffc629', '#c99400', '#ffffff'],
              });
            };
            if (window.confetti) {
              runConfetti();
            } else {
              var s = document.createElement('script');
              s.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
              s.async = true;
              s.onload = runConfetti;
              document.head.appendChild(s);
            }
          }

          setTimeout(() => {
            btn.classList.remove('is-success');
            btn.innerHTML = original;
          }, 2400);
        };

        document.addEventListener(
          'cart:update',
          (event) => {
            if (event.detail?.data?.didError) {
              btn.classList.remove('is-loading');
              return;
            }
            onAdded();
          },
          { once: true }
        );

        setTimeout(() => btn.classList.remove('is-loading'), 5000);
      });
    });
  }

  /* ── Stock / ventes compteur produit ── */
  function initProductCounters() {
    document.querySelectorAll('[data-product-count]').forEach((el) => {
      const target = parseInt(el.getAttribute('data-product-count') || '0', 10);
      if (!target) return;
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min((now - start) / 1600, 1);
            el.textContent = Math.round(target * (1 - Math.pow(1 - t, 3)));
            if (t < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          io.disconnect();
        },
        { threshold: 0.5 }
      );
      io.observe(el);
    });
  }

  function initPdpSoldOutBadge() {
    if (document.body.dataset.productAvailable !== 'false') return;

    var media = document.querySelector('.product-information__media');
    if (!media || media.querySelector('.ef-badge--soldout')) return;

    var badge = document.createElement('span');
    badge.className = 'ef-badge ef-badge--soldout ef-badge--pdp';
    badge.setAttribute('aria-label', 'Rupture de stock');
    badge.textContent = 'Rupture de stock';
    media.appendChild(badge);
  }

  function boot() {
    initGalleryMorph();
    initSlideshowMorph();
    initDesktopZoom();
    initVariantSwap();
    initConfiguratorPremium();
    initAddToCartAnimation();
    initProductCounters();
    initPdpSoldOutBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
